import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { SubmitButton } from '@/components/functional/Form/SubmitButton';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { LinkButton } from '@/components/ui/Button/LinkButton';
import { ModalFooterAction } from '@/components/ui/Modal/Modal';
import { LaunchIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { hotlineTermsModalStyle } from '@/feature/hotline/component/HotlineTermsModal/style';
import { useStaticPageHtmlParser } from '@/hooks/pages/static/useStaticPageHtmlParser';
import { useBoolState } from '@/hooks/state/useBoolState';
import { TERMS_HOTLINE_HTML, TERMS_HOTLINE_SECTION_ID, } from '@/utils/constants/static/tpl/terms';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン 利用規約同意モーダル 内容部分
 */
export const HotlineTermsModalContent = (props) => {
    const { onClickAgree, onClickDisagree, submitting } = props;
    // 非活性状態の制御
    const { boolState: scrolled, changeTrue: setScrolled } = useBoolState();
    /**
     * 規約のスクロール位置が最下部か判定
     */
    const judgeScrolled = useCallback((element) => {
        const { clientHeight, scrollHeight, scrollTop } = element;
        // 小数点以下の誤差の考慮 + padding-bottom 分を含めた 8px を閾値とする
        const isScrolled = Math.abs(scrollHeight - scrollTop - clientHeight) <= 8;
        if (isScrolled) {
            setScrolled();
        }
    }, [setScrolled]);
    /**
     * 規約内容のスクロールイベント
     */
    const onScrollTermContainer = useCallback((e) => {
        judgeScrolled(e.currentTarget);
    }, [judgeScrolled]);
    /** HTML に変換された規約内容 */
    const content = useStaticPageHtmlParser({ html: TERMS_HOTLINE_HTML });
    const style = hotlineTermsModalStyle();
    return (_jsxs(_Fragment, { children: [_jsx("section", Object.assign({ className: style.termsContent({ class: 'p-8' }), onScroll: scrolled ? undefined : onScrollTermContainer }, { children: content })), _jsxs(RouterLink, Object.assign({ className: style.link(), target: '_blank', to: `${pagePath.terms()}#${TERMS_HOTLINE_SECTION_ID}` }, { children: [_jsx("span", Object.assign({ className: style.linkText() }, { children: "\u5225\u30BF\u30D6\u3067\u8868\u793A\u3059\u308B" })), _jsx(LaunchIcon, { color: 'info', size: 'sm' })] })), _jsxs(ModalFooterAction, Object.assign({ className: style.buttons() }, { children: [_jsx(SubmitButton, Object.assign({ color: 'orange', disabled: submitting || !scrolled, loading: submitting, onClick: onClickAgree, size: 'md', type: 'button' }, { children: "\u540C\u610F\u3057\u3066\u30B5\u30FC\u30D3\u30B9\u3092\u958B\u59CB\u3059\u308B" })), _jsx(LinkButton, Object.assign({ color: 'gray', disabled: submitting, onClick: onClickDisagree, size: 'md', to: pagePath.mypage.client.index() }, { children: "\u540C\u610F\u3057\u306A\u3044" }))] }))] }));
};
